'use strict';

/**
 * Common functionality and utilities that is useful to several different parts
 * of the Contributor Tool.
 */
(function(_, moment) {
  window.atex = window.atex || {};
  window.atex.dam = window.atex.dam || {};
  window.atex.dam.isTest = false;
  window.atex.dam.cfg = window.atex.dam.cfg || {};

  /**
   * If there is no window.console, or a window.console with insufficient
   * support for the methods we want to use, we create our own wrapping
   * implementations, just re-using window.console.log();
   *
   * NOTE: The entire window.console creation block can be safely removed when
   * dam is using version 0.9.1 or later of the OneCMS Code Library.
   */

  window.console = window.console || {
    log : function(s) {
    }
  };

  window.console.info = window.console.info || function(s) {
    window.console.log(s);
  };
  window.console.warn = window.console.warn || function(s) {
    window.console.log(s);
  };
  window.console.error = window.console.error || function(s) {
    window.console.log(s);
  };

  var assertRequiredParameter = function(callerFunction, parameter, parameterName) {
    if (_.isUndefined(parameter) || _.isNull(parameter)) {
      throw Error('atex.dam.AngularUtils.' + callerFunction + ' called with invalid ' + parameterName + ' parameter (' + parameter + ')!');
    }
  };

  /**
   * Utility Angular functions.
   */
  atex.dam.AngularUtils = _.extend({}, atex.AngularUtils, {
    /**
     * Constructs an angular model path from a path which is an array of
     * strings. The resulting path (a string) uses bracket notation to be able
     * to deal with dots in path segments.
     *
     * Using undefined or null for the path parameter will cause en Error to be
     * thrown.
     */
    getModelPathFromPathArray: function (path) {
      assertRequiredParameter('getModelPathFromPathArray', path, 'path');

      return path.map(function (val) {
        return '["' + val + '"]';
      }).join('');
    },

    /**
     * Constructs a field id from a path (an array of strings). The resulting id
     * uses underscores as path separators and also replaces any dot with an
     * underscore.
     *
     * Using undefined or null for the path parameter will cause en Error to be
     * thrown.
     */
    getFieldIdFromPathArray: function (path) {
      assertRequiredParameter('getFieldIdFromPathArray', path, 'path');

      return path.map(function (val) {
        return ('' + val).replace(/\./g, '_');
      }).join('_');
    },

    isPolicyContent: function (contentId) {
      return (contentId.startsWith('policy:'));
    },

    getNode: function(element, id) {
      if ($(element).context) {
        var node = $(element).context.parentNode;
        if (node) {
          return $(node).find(id);
        }
      }
    },

    width: function (element, offset) {
      var parent = $(element).parent();
      if (parent) {
        var width = parent.width();
        parent.width(width + offset);
      }
    },

    getWidth: function (element) {
      var parent = $(element).parent();
      if (parent) {
        return parent.width();
      }
    },

    removePolicyPrefix: function (contentId) {
      if (contentId.startsWith('policy:')) {
        contentId = contentId.replace('policy:', '');
      }

      return contentId;
    },

    addPrefix: function (contentId) {
      if (contentId && !contentId.startsWith('contentid/')) {
        contentId = 'contentid/' + contentId;
      }

      return contentId;
    },

    removePrefix: function (contentId) {
      if (contentId.startsWith('contentid/')) {
        contentId = contentId.replace('contentid/', '');
      }

      return contentId;
    },

    buildPermissionRequest: function (contentId, permissionType, decorate) {
      return {
        'id': contentId,
        'permission': permissionType,
        'decorate': (typeof decorate === 'undefined' ? true : decorate)
      };
    },

    /**
     * Fix urls inside contentData aspect data is the parent of aspects
     */
    fixUrls: function (data) {
      if (data.aspects.contentData.data.objectType === "image") {
        // Setup thumbUrl and url on contentData to be used for thumblist /
        // thumb and for full page preview
        data.aspects.contentData.data.thumbUrl = "/image/" + data.version + "/" + data.version + ".jpg?w=240";
        data.aspects.contentData.data.lowUrl = "/image/" + data.version + "/" + data.version + ".jpg?w=400";
        data.aspects.contentData.data.url = "/image/" + data.version + "/" + data.version + ".jpg";
      }
      if (data.aspects.contentData.data.mediaEntities && data.aspects.contentData.data.mediaEntities[0]) {
        // this is for tweets
        data.aspects.contentData.data.thumbUrl = data.aspects.contentData.data.mediaEntities[0].mediaURL;
        data.aspects.contentData.data.externalURL = "http://" + data.aspects.contentData.data.mediaEntities[0].displayURL;
      } else if (data.aspects.contentData.data.objectType === "instagram" && data.aspects.contentData.data.standardVideoUrl) {
        // this is for instagram video
        data.aspects.contentData.data.thumbUrl = data.aspects.contentData.data.url;
        data.aspects.contentData.data.mp4Url = data.aspects.contentData.data.standardVideoUrl;
      } else if (data.aspects['atex.Files']) {
        if (data.aspects['atex.Files'].data.files['page/page.jpg']) {
          data.aspects.contentData.data.thumbUrl = "/filedelivery/" + data.version + "/page/page.jpg"; //+ data.aspects['atex.Files'].data.files['page/page.jpg'].filePath;
        }
        if (data.aspects['atex.Files'].data.files['source/page.pdf']) {
          data.aspects.contentData.data.pdfUrl = "/filedelivery/" + data.version + "/" + data.aspects['atex.Files'].data.files['source/page.pdf'].filePath;
        }
        if (data.aspects['atex.Files'].data.files['video/video.jpg']) {
          data.aspects.contentData.data.thumbUrl = "/filedelivery/" + data.version + "/video/video.jpg"; //data.aspects['atex.Files'].data.files['video/video.jpg'].filePath;
        }
        if (data.aspects['atex.Files'].data.files['video/video.mp4']) {
          data.aspects.contentData.data.mp4Url = "/filedelivery/" + data.version + "/" + data.aspects['atex.Files'].data.files['video/video.mp4'].filePath;
        }
        if (data.aspects['atex.Files'].data.files['video/video.webm']) {
          data.aspects.contentData.data.webmUrl = "/filedelivery/" + data.version + "/" + data.aspects['atex.Files'].data.files['video/video.webm'].filePath;
        }
        if (data.aspects['atex.Files'].data.files['graphic/graphic.jpg']) {
          data.aspects.contentData.data.thumbUrl = "/filedelivery/" + data.version + "/graphic/graphic.jpg"; //+ data.aspects['atex.Files'].data.files['graphic/graphic.jpg'].filePath;
        }
      }

      if (data.aspects['atex.print.Page']) {
        var printPage = data.aspects['atex.print.Page'].data;

        if (printPage && printPage.hasPdf) {
          data.aspects.contentData.data.pdfUrl = "/onecms/layout/handj/content/pagepdf/" +
            printPage.pageId + "#page=" + printPage.pageSequence;
        }
      }
    },

    // Before passing contentData to ContentService (remove fields not in beans to avoid Uncaught exception from WS)
    // the url, pdfUrl, mp4Url, webmUrl, externalURL, thumbUrl, lowUrl are added by fixUrls.
    sanitizeContentData: function (contentData) {
      delete contentData.data.pdfUrl;
      delete contentData.data.mp4Url;
      delete contentData.data.webmUrl;
      delete contentData.data.externalURL;
      if (contentData.data.objectType !== "instagram") {
        delete contentData.data.url;
        delete contentData.data.lowUrl;
        delete contentData.data.thumbUrl;
      }
    },

    hasVideo: function (data) {
      if (data.aspects.contentData.data.inputTemplate === "p.DamVideo") {
        return true;
      }
      if (data.aspects.contentData.data.inputTemplate === "p.DamInstagram" && data.aspects.contentData.data.standardVideoUrl) {
        return true;
      }
      return false;
    },

    getURLParameter: function (name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null;
    },

    highlightInputFields : function(defaultStyle){
      var input = document.querySelectorAll('[highlightinputcss]');
      var i, j, elements;
      for (i = 0; i < input.length; i++) {
        var style = defaultStyle;
        if (input[i].getAttribute("highlightinputcss") !== null && input[i].getAttribute("highlightinputcss") !== "") {
          style = input[i].getAttribute("highlightinputcss");
        }
        if(!style){
          continue;
        }
        if ((input[i].tagName === "INPUT" && input[i].value !== "")) {
          if (input[i].originalStyle === undefined){
            input[i].originalStyle = input[i].style.cssText;
          }
          input[i].style.cssText = style;
        }else if (input[i].tagName === "DIV" && input[i].innerText !== "" ){
          if (input[i].querySelector('.ng-binding.ng-scope') !== null){
            elements = input[i].querySelectorAll('.ng-binding.ng-scope');
            for (j = 0; j < elements.length; j++) {
              if (elements[j].originalStyle === undefined){
                elements[j].originalStyle = input[i].querySelector('.ng-binding.ng-scope').style.cssText;
              }
              elements[j].style.cssText = style;
            }
          }else if (input[i].querySelector('.select2-search-choice') !== null){
            elements = input[i].querySelectorAll('.select2-search-choice');
            for (j = 0; j < elements.length; j++) {
              if (elements[j].originalStyle === undefined){
                elements[j].originalStyle = input[i].querySelector('.select2-search-choice').style.cssText;
              }
              elements[j].style.cssText = style;
            }
          }
        }else{
          if (input[i].tagName === "INPUT" && input[i].originalStyle !== undefined ) {
            input[i].style.cssText = input[i].originalStyle;
          }else if (input[i].tagName === "DIV" ){
            if(input[i].querySelector('.ng-binding.ng-scope') !== null && input[i].querySelector('.ng-binding.ng-scope').originalStyle !== undefined){
              elements = input[i].querySelectorAll('.ng-binding.ng-scope');
              for (j = 0; j < elements.length; j++) {
                elements[j].style.cssText = input[i].querySelector('.ng-binding.ng-scope').originalStyle;
              }
            }else if (input[i].querySelector('.select2-search-choice') !== null && input[i].querySelector('.select2-search-choice').originalStyle !== undefined){
              elements = input[i].querySelectorAll('.select2-search-choice');
              for (j = 0; j < elements.length; j++) {
                elements[j].style.cssText = input[i].querySelector('.select2-search-choice').originalStyle;
              }
            }
          }
        }
      }
      return ;
    },

    /**
     * Calculate appropriate width and height for thumb and thumblist view representation
     */
    fixWidthHeight: function (document, currLineHeight) {
      var _width = atex.onecms.ObjectUtils.getByPath(document, "_data/aspects/atex.Image/data/width") ||
        atex.onecms.ObjectUtils.getByPath(document, "_data/aspects/contentData/data/width");
      var _height = atex.onecms.ObjectUtils.getByPath(document, "_data/aspects/atex.Image/data/height") ||
        atex.onecms.ObjectUtils.getByPath(document, "_data/aspects/contentData/data/height");
      if (_width > 0 && _height > 0) {
        var width = _width * 1;
        var height = _height * 1;

        var _rotation = atex.onecms.ObjectUtils.getByPath(document, "_data/aspects/atex.ImageEditInfo/data/rotation");
        if (_rotation && (_rotation !== 0 && _rotation !== 180)) {
          width = _height;
          height = _width;
        }
        document["calcWidth"] = currLineHeight * width / height;
      }
      document["calcHeight"] = currLineHeight;
    },

    entityFromList: function (entityStrings) {
      return {
        id: entityStrings[0],
        name: entityStrings[0],
        entities: entityStrings.length > 1 ? [this.entityFromList(entityStrings.slice(1))] : [],
        attributes: []
      };
    },

    entityFromPath: function (pathString) {
      return this.entityFromList(pathString.split("/"));
    },

    entityToPathArray: function (entity) {
      var pathArray = [entity.name];
      if (typeof entity.entities !== 'undefined' && entity.entities.length > 0) {
        pathArray = pathArray.concat(this.entityToPathArray(entity.entities[0]));
      }
      return pathArray;
    },

    entityToPath: function (entity) {
      return this.entityToPathArray(entity).join('/');
    },

    getFileExtension: function (path) {
      var ext = '';
      if (!path || path === '') {
        return ext;
      }
      if (path.lastIndexOf('.') === -1) {
        return ext;
      }
      return path.substring(path.lastIndexOf('.') + 1);
    },

    getExtensionFromMimeType: function (mimeType) {
      switch (mimeType) {
        case 'image/jpeg':
          return 'jpg';
        case 'image/tiff':
          return 'tiff';
        case 'image/png ':
          return 'png';
        case 'image/gif':
          return 'gif';
        case 'application/pdf':
          return 'pdf';
        case 'application/postscript':
          return 'ai';
        case 'audio/mpeg':
          return 'mp3';
        case 'audio/ogg':
          return 'ogg';
        case 'video/3gpp':
          return '3gpp';
        case 'video/mpeg':
          return 'mpeg';
        case 'video/quicktime':
          return 'mov';
        case 'video/x-flv':
          return 'flv';
        case 'video/mp4':
          return 'mp4';
        case 'text/html':
          return 'html';
        case 'text/xml':
          return 'xml';
        case 'text/plain':
          return 'txt';
      }
    },

    buildEntityPath: function (entity) {
      var path = entity.id;
      var next = entity.entities;
      while (next !== undefined && next.length > 0) {
        path = path + '/' + next[0].id;
        next = next[0].entities;
      }
      return path;
    },

    getDimensions: function (entry) {
      return atex.onecms.ObjectUtils.getByPath(entry, 'data/aspects/atex.Metadata/data/metadata/dimensions') || [];
    },

    getDimension: function (entry, dimensionId) {
      var dimensions = this.getDimensions(entry);

      var dimension = _.find(dimensions, function (dim) {
        return dim.id === dimensionId;
      });

      return dimension;
    },

    /**
     * Get the partition name from the content metadata.
     *
     * @param data the content (aspects needs to be in .data.aspects).
     * @returns The partition name or undefined if not found.
     */
    getContentPartition: function (data) {
      var dimension = atex.dam.AngularUtils.getDimension(data, "dimension.partition") || {};
      var entities = dimension.entities || [];
      return (_.first(entities) || {}).name;
    },

    cleanDimension: function (destination, source, dimensionId) {
      var sourceDim = this.getDimension(source, dimensionId);

      if (sourceDim) {
        var destinationDim = this.getDimension(destination, dimensionId);

        if (destinationDim) {
          var destinationDims = this.getDimensions(destination);

          var index = destinationDims.indexOf(destinationDim);

          if (index > -1) {
            destinationDims.splice(index, 1);
          }
        }
      }
    },

    mergeDimension: function (dstEntities, srcEntities, isSingleValue) {
      if (dstEntities.length === 0) {
        angular.extend(dstEntities, srcEntities);
        return true;
      }
      var dirty = false;
      for (var i = 0; i < srcEntities.length; i++) {
        var currId = this.buildEntityPath(srcEntities[i]);
        var toAdd = true;
        for (var j = 0; j < dstEntities.length; j++) {
          var currDstId = this.buildEntityPath(dstEntities[j]);
          if (currId === currDstId) {
            toAdd = false;  // Id already in dst
            break;
          }
        }
        if (toAdd) {
          if (isSingleValue) {
            dstEntities.length = 0; // Reset dest entities
          }
          dstEntities.push(srcEntities[i]);
          dirty = true;
        }
      }
      return dirty;
    },

    unmergeDimension: function (dstEntities, srcEntities) {
      if (dstEntities.length === 0) {
        return false;
      }
      var dirty = false;

      for (var i = 0; i < srcEntities.length; i++) {
        var currId = this.buildEntityPath(srcEntities[i]);
        var indexToRemove = -1;
        for (var j = 0; j < dstEntities.length; j++) {
          var currDstId = this.buildEntityPath(dstEntities[j]);
          if (currId === currDstId) {
            indexToRemove = j;  // Id is in dstContent
            break;
          }
        }
        if (indexToRemove >= 0) {
          dstEntities.splice(indexToRemove);
          dirty = true;
        }
      }
      return dirty;
    },

    mergeMetadata: function (dstContent, srcContent, singleValueDimensions) {
      var findDimensionById = function (dimensions, id) {
        var dimension;
        dimensions.forEach(function (current) {
          if (current.id === id) {
            dimension = current;
          }
        });
        return dimension;
      };

      var dirty = true;

      if (!dstContent.data.aspects['atex.Metadata']) {
        dstContent.data.aspects['atex.Metadata'] = angular.copy(srcContent.data.aspects['atex.Metadata']);
        return dirty;
      }
      if (!dstContent.data.aspects['atex.Metadata'].data.metadata.dimensions || dstContent.data.aspects['atex.Metadata'].data.metadata.dimensions.length <= 0) {
        dstContent.data.aspects['atex.Metadata'].data.metadata = angular.copy(srcContent.data.aspects['atex.Metadata'].data.metadata);
        return dirty;
      }
      dirty = false;
      var srcMetadata = srcContent.data.aspects['atex.Metadata'];
      var dstMetadata = dstContent.data.aspects['atex.Metadata'];
      if (!srcMetadata) {
        return false;
      }
      for (var i = 0; i < srcMetadata.data.metadata.dimensions.length; i++) {
        if (srcMetadata.data.metadata.dimensions[i].entities && srcMetadata.data.metadata.dimensions[i].entities.length > 0) {
          var metaId = srcMetadata.data.metadata.dimensions[i].id;
          var dstDimension = findDimensionById(dstMetadata.data.metadata.dimensions, metaId);
          if (!dstDimension) {
            // Copy the source dimension and continue
            dstContent.data.aspects['atex.Metadata'].data.metadata.dimensions.push(angular.copy(srcMetadata.data.metadata.dimensions[i]));
            dirty = true;
            continue;
          }
          var isSingleValue = singleValueDimensions && singleValueDimensions.length && singleValueDimensions.indexOf(metaId) >= 0;
          var _ret = this.mergeDimension(dstDimension.entities, srcMetadata.data.metadata.dimensions[i].entities, isSingleValue);
          if (_ret === true) {
            delete dstDimension.entities_element_types;
            dirty = true;
          }
        }
      }
      if (dirty) {
        delete dstMetadata.data.metadata.dimensions_element_types;
      }
      return dirty;
    },

    unmergeMetadata: function (dstContent, srcContent) {
      var findDimensionById = function (dimensions, id) {
        var dimension;
        dimensions.forEach(function (current) {
          if (current.id === id) {
            dimension = current;
          }
        });
        return dimension;
      };

      var dirty = true;

      if (!dstContent.data.aspects['atex.Metadata'] || !dstContent.data.aspects['atex.Metadata'].data.metadata.dimensions ||
        dstContent.data.aspects['atex.Metadata'].data.metadata.dimensions.length <= 0) {
        return false;
      }

      dirty = false;
      var srcMetadata = srcContent.data.aspects['atex.Metadata'];
      var dstMetadata = dstContent.data.aspects['atex.Metadata'];
      if (!srcMetadata || srcMetadata.data.metadata.dimensions.length <= 0) {
        return false;
      }
      for (var i = 0; i < srcMetadata.data.metadata.dimensions.length; i++) {
        if (srcMetadata.data.metadata.dimensions[i].entities && srcMetadata.data.metadata.dimensions[i].entities.length > 0) {
          var metaId = srcMetadata.data.metadata.dimensions[i].id;
          var dstDimension = findDimensionById(dstMetadata.data.metadata.dimensions, metaId);
          if (!dstDimension) {
            continue;
          }

          var _ret = this.unmergeDimension(dstDimension.entities, srcMetadata.data.metadata.dimensions[i].entities);
          if (_ret === true) {
            dirty = true;
            delete dstDimension.entities_element_types;
          }
        }
      }
      if (dirty) {
        delete dstMetadata.data.metadata.dimensions_element_types;
      }
      return dirty;
    },

    copySecInsParent: function (dstContent, srcContent) {
      var srcInsInfo = srcContent.data.aspects['p.InsertionInfo'];
      if (!srcInsInfo) {
        return false;
      }
      var dstInsInfo = dstContent.data.aspects['p.InsertionInfo'];
      var dirty = true;
      if (!dstInsInfo) {
        dstContent.data.aspects['p.InsertionInfo'] = angular.copy(srcInsInfo);
        return dirty;
      }
      dirty = false;
      if (dstInsInfo.data.securityParentId !== srcInsInfo.data.securityParentId) {
        dstInsInfo.data.securityParentId = srcInsInfo.data.securityParentId;
        dirty = true;
      }
      if (srcInsInfo.data.insertParentId && dstInsInfo.data.insertParentId !== srcInsInfo.data.insertParentId) {
        dstInsInfo.data.insertParentId = srcInsInfo.data.insertParentId;
        dirty = true;
      }
      return dirty;
    },

    copySecParentAsAssociatedSite: function (dstContent, srcContent) {
      var srcInsInfo = srcContent.data.aspects['p.InsertionInfo'];
      if (!srcInsInfo) {
        return false;
      }
      var dstInsInfo = dstContent.data.aspects['p.InsertionInfo'];
      var dirty = true;
      if (!dstInsInfo) {
        dstContent.data.aspects['p.InsertionInfo'] = angular.copy(srcInsInfo);
        return dirty;
      }
      dirty = false;
      if (!dstInsInfo.data.associatedSites) {
        dstInsInfo.data.associatedSites = [];
        dstInsInfo.data.associatedSites.push(srcInsInfo.data.securityParentId);
        delete dstInsInfo.data.associatedSites_element_types;
        dirty = true;
      } else {
        var found = false;
        dstInsInfo.data.associatedSites.forEach(function (site) {
          if (site === srcInsInfo.data.securityParentId) {
            found = true;
          }
        });
        if (!found) {
          dstInsInfo.data.associatedSites.push(srcInsInfo.data.securityParentId);
          delete dstInsInfo.data.associatedSites_element_types;
          dirty = true;
        }
      }

      return dirty;
    },

    getWithContentId: function(id) {
      if (!id.startsWith('contentid/')) {
        return 'contentid/' + id;
      }
      return id;
    },

    withExternalId: function(source, responseInfo) {
      var siteExternalId = atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/aspects/contentData/data/externalId');

      if (siteExternalId) {
        return _.extend({}, source, {externalId: siteExternalId});
      } else {
        return source;
      }
    },

    setFolder: function (dstContent, folderId, folderName, multiAssign) {

      var dirty = true;
      var foldersDimensionID = "dimension.DeskFolders";
      var folderMetaEntity = {
        "_type": "com.polopoly.metadata.Entity",
        "name": folderName,
        "id": folderId
      };
      var folderMetaDimension = {
        "_type": "com.polopoly.metadata.Dimension",
        "name": "Folders",
        "id": foldersDimensionID,
        "entities": [folderMetaEntity]
      };

      if (!dstContent.data.aspects['atex.Metadata']) {
        dstContent.data.aspects['atex.Metadata'] = {
          data: {
            _type: 'atex.Metadata',
            taxonomyIds: ['p.StandardCategorization'],
            metadata: {
              _type: "com.polopoly.metadata.Metadata",
              dimensions: [folderMetaDimension]
            }
          }
        };
        return dirty;
      } else {
        var dimensions = dstContent.data.aspects['atex.Metadata'].data.metadata.dimensions;
        var dimension = _.find(dimensions, function (dim) {
          return dim.id === foldersDimensionID;
        });
        if (!dimension) {
          dstContent.data.aspects['atex.Metadata'].data.metadata.dimensions.push(folderMetaDimension);
          delete dstContent.data.aspects['atex.Metadata'].data.metadata.dimensions_element_types;
          return dirty;
        } else {
          //Check the old value
          if (multiAssign) {
            // The content can be assigned to multiple folders
            if (dimension.entities.length > 0) {
              var entity = _.find(dimension.entities, function (ent) {
                return ent.id === folderId;
              });
              if (entity) {
                //Nothing to do... (TODO: check if we need to check also the name in case it has changed!!!
                return false;
              }
            }
          } else {
            // The content can be only in one folder, check entities length and set the only one needed
            if (dimension.entities.length > 1) {
              // dirty in any case
              dimension.entities = [folderMetaEntity];
              delete dimension.entities_element_types;
              return dirty;
            }
            if (dimension.entities.length === 1) {
              if (dimension.entities[0].id === folderId) {
                //Nothing to do... (TODO: check if we need to check also the name in case it has changed!!!
                return false;
              } else {
                dimension.entities[0] = folderMetaEntity;
                delete dimension.entities_element_types;
                return dirty;
              }
            }
          }
          // If here we need to push the entity
          dimension.entities.push(folderMetaEntity);
          delete dimension.entities_element_types;
        }
        return dirty;
      }
    },

    unsetFolder: function (dstContent, folderId) {
      if (!dstContent.data.aspects['atex.Metadata']) {
        return false;
      }
      var dirty = true;
      var foldersDimensionID = "dimension.DeskFolders";
      var dimensions = dstContent.data.aspects['atex.Metadata'].data.metadata.dimensions;
      var dimension = _.find(dimensions, function (dim) {
        return dim.id === foldersDimensionID;
      });
      if (!dimension || dimension.entities.length <= 0) {
        return false;
      }
      var indexToRemove = _.indexOf(_.pluck(dimension.entities, 'id'), folderId);
      if (indexToRemove < 0) {
        return false;
      }
      dimension.entities.splice(indexToRemove, 1);
      delete dimension.entities_element_types;
      return dirty;
    },

    fromObjTypeArrayToIDsArray: function (types) {
      var i = 0;
      for (i = 0; i < types.length; i++) {
        types[i] = types[i].id;
      }
    },

    fromIDsArrayToObjTypeArray: function (types) {
      var i = 0;
      for (i = 0; i < types.length; i++) {
        types[i] = {
          id: types[i]
        };
      }
    },

    getIdsArray: function (items) {
      var arr = [];
      if (items && items.length > 0) {
        items.forEach(function (item) {
          arr.push(item.id);
        });
      }
      return arr;
    },

    /*jslint bitwise: true */
    UUID: function () {
      var nbr, randStr = "";
      do {
        randStr += (nbr = Math.random()).toString(16).substring(2);
      } while (randStr.length < 30);
      return [randStr.substring(0, 8), "-", randStr.substring(8, 4), "-4", randStr.substring(12, 3), "-", ((nbr * 4 | 0) + 8).toString(16), randStr.substring(15, 3),
        "-", randStr.substring(18, 12)].join("");
    },
    /*jslint bitwise: false */

    attributeLabel: function (attribute) {
      return "<i class='" + attribute.icon + "'></i>&nbsp;" + attribute.name;
    },

    statusLabel: function (status) {
      var color = status.color;

      if (!this.isHexColor(color)) {
        color = this.getHex(color);
      }

      var text = this.textColorOnBgColor(color);
      return '<span class="label label-list" style="background-color: ' + color + '; color:' + text + '; border: 1px solid gray">' + status.name + '</span> ';
    },

    getHex: function (color) {
      var d = document.createElement("div");
      d.style.color = color;
      document.body.appendChild(d);

      return window.getComputedStyle(d).color;
    },

    isHexColor: function (input) {
      var hexPattern = /#?([A-F]|[a-f]|\d){6}$/;
      return hexPattern.test(input);
    },

    textColorOnBgColor: function (bgColor) {
      var defColor = '#ffffff';
      if (!bgColor || bgColor.length <= 0) {
        return defColor;
      }
      var red, green, blue;
      if (bgColor[0] === '#') {
        // Color in the following format: '#12FFA2' or '#FAC'
        bgColor = bgColor.substring(1);
        if (bgColor.length !== 3 && bgColor.length !== 6) {
          return defColor;
        }
        if (bgColor.length === 6) {
          red = parseInt(bgColor.slice(0, 2), 16);
          green = parseInt(bgColor.slice(2, 4), 16);
          blue = parseInt(bgColor.slice(4, 6), 16);
        } else {
          red = parseInt(bgColor.slice(0, 1) + bgColor.slice(0, 1), 16);
          green = parseInt(bgColor.slice(1, 2) + bgColor.slice(1, 2), 16);
          blue = parseInt(bgColor.slice(2, 3) + bgColor.slice(2, 3), 16);
        }
      } else if (bgColor.length >= 10 && bgColor.startsWith("rgb(")) {
        // Color in the following format: 'rgb(120,14,50)'
        var rgbArray = bgColor.substring(4, bgColor.length - 1).replace(/ /g, '').split(',');
        red = parseInt(rgbArray[0]);
        green = parseInt(rgbArray[1]);
        blue = parseInt(rgbArray[2]);
      } else {
        return defColor;
      }
      if ((red * 0.299 + green * 0.587 + blue * 0.114) > 185) {
        return '#000000';
      } else {
        return '#ffffff';
      }
    },

    textColorOnBgColorByParam: function (bgColor, limit) {
      var defColor = '#ffffff';
      if (!bgColor || bgColor.length <= 0) {
        return defColor;
      }
      var red, green, blue;
      if (bgColor[0] === '#') {
        // Color in the following format: '#12FFA2' or '#FAC'
        bgColor = bgColor.substring(1);
        if (bgColor.length !== 3 && bgColor.length !== 6) {
          return defColor;
        }
        if (bgColor.length === 6) {
          red = parseInt(bgColor.slice(0, 2), 16);
          green = parseInt(bgColor.slice(2, 4), 16);
          blue = parseInt(bgColor.slice(4, 6), 16);
        } else {
          red = parseInt(bgColor.slice(0, 1) + bgColor.slice(0, 1), 16);
          green = parseInt(bgColor.slice(1, 2) + bgColor.slice(1, 2), 16);
          blue = parseInt(bgColor.slice(2, 3) + bgColor.slice(2, 3), 16);
        }
      } else if (bgColor.length >= 10 && bgColor.startsWith("rgb(")) {
        // Color in the following format: 'rgb(120,14,50)'
        var rgbArray = bgColor.substring(4, bgColor.length - 1).replace(/ /g, '').split(',');
        red = parseInt(rgbArray[0]);
        green = parseInt(rgbArray[1]);
        blue = parseInt(rgbArray[2]);
      } else {
        return defColor;
      }
      if ((red * 0.299 + green * 0.587 + blue * 0.114) > limit) {
        return '#000000';
      } else {
        return '#ffffff';
      }
    },

    toUTCDate: function (millis) {
      function pad(number) {
        if (number < 10) {
          return '0' + number;
        }
        return number;
      }

      var inMillis = millis * 1;
      var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
      d.setUTCSeconds(inMillis / 1000);
      var date = new Date(inMillis);
      var str = date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate()) + 'T' + pad(date.getUTCHours()) + ':' +
        pad(date.getUTCMinutes()) + ':' + pad(date.getUTCSeconds()) + 'Z';
      return str;
    },

    cleanUpJson: function (o_in, onlyElementTypes) {

      function cleanUpJson_inner(o, level) {
        var keys = Object.keys(o);
        for (var idx = 0; idx < keys.length; idx++) {
          var k = keys[idx];
          if (k.indexOf('_element_types') >= 0) {
            delete o[k];
          } else if (!onlyElementTypes && k.indexOf('_type') >= 0) {
            if (level > 0 || (k.indexOf('_type') > 0)) {
              delete o[k];
            }
          } else {
            var subObject = o[k];
            if (subObject instanceof Object) {
              o[k] = cleanUpJson_inner(subObject, level + 1);
            } else if (subObject.constructor === Array) {
              var arr = [];
              for (var subIdx = 0; subIdx < subObject.length; subIdx++) {
                arr.push(cleanUpJson_inner(subObject[subIdx], level + 1));
              }
              o[k] = arr;
            }
          }
        }
        return o;
      }

      // make a copy of the object
      var o = JSON.parse(JSON.stringify(o_in));
      return cleanUpJson_inner(o, 0);
    },

    checkImageMetadataType: function (tags, section, key, keyCfg) {
      if (keyCfg.type instanceof Array) {
        if (keyCfg.type.length > 0) {
          var cfgArrayTypes = keyCfg.type[0];
          if (cfgArrayTypes === 'string') {
            if (tags[section][key + '_type'] !== 'java.util.ArrayList') {
              tags[section][key] = [String(tags[section][key])];
              tags[section][key + '_type'] = 'java.util.ArrayList';
            }
          }
        }
      } else if (keyCfg.type === 'string') {
        if (tags[section][key + '_type'] !== 'java.lang.String') {
          tags[section][key] = String(tags[section][key]);
          tags[section][key + '_type'] = 'java.lang.String';
        }
      } else if (keyCfg.type === 'date' || keyCfg.type === 'dateTime' || keyCfg.type === 'time') {
        if (tags[section][key + '_type'] === 'java.lang.Double') {
          tags[section][key] = String(tags[section][key]);
          tags[section][key + '_type'] = 'java.lang.String';
        }
      }
    },

    verifyImageMetadataTypes: function (data, $rootScope) {
      if (!$rootScope.atexIptcfieldsConfig || !data || !data.tags) {
        return;
      }
      for (var section in  data.tags) {
        if (!section.endsWith("_type")) {
          if (typeof(data.tags[section]) !== 'object') {
            continue;
          }
          for (var key in  data.tags[section]) {
            if (!key.endsWith('_type') && !key.endsWith('_element_types')) {
              var myKey = section + "/" + key;
              if ($rootScope.atexIptcfieldsConfig[myKey]) {
                this.checkImageMetadataType(data.tags, section, key, $rootScope.atexIptcfieldsConfig[myKey]);
              }
            }
          }
        }
      }
    },
    copyNoHash: function (obj) {
      if (typeof obj === 'undefined') {
        return undefined;
      }

      return JSON.parse(angular.toJson(obj));
    },

    getField: function (data, path, id) {
      var _fields = atex.onecms.ObjectUtils.getByPath(data, path) || [];
      return _.find(_fields, function (field) {
        return field.key === id;
      });
    },

    getFieldValues: function (data, path, id) {
      var values;

      var _field = this.getField(data, path, id);
      if (_field && _field.values && _field.values.length > 0) {
        values = ((_field.type === "BOOLEAN") || (_field.type === "STRING") || (_field.type === "ENGAGE")) ? _field.values[0] : _field.values;
      }

      return values;
    },

    getTypeField: function (data, path) {
      return this.getField(data, path, 'atex_desk_objectType');
    },

    getTypeValues: function (data, path) {
      return this.getFieldValues(data, path, "atex_desk_objectType");
    },

    addTypeField: function (types, data, path) {
      var _fields = atex.onecms.ObjectUtils.getByPath(data, path) || [];
      var _field = this.getTypeField(data, path);

      if (_field) {
        _field.values = types;
        delete _field.values_element_types;
      } else {
        _field = {
          "key": "atex_desk_objectType",
          "type": "LIST",
          "subQuery": false,
          "values": types
        };

        _fields.push(_field);
      }
    }
  });

  var mimeTypeIconMappings = {
    image : 'img/image-x-generic.png',
    text : 'img/text-x-generic.png',
    application : 'img/application-octet-stream.png',
    video : 'img/video-x-generic.png',
    audio : 'img/audio-x-generic.png'
  };

  /**
   * Utility functions for data presentation logic.
   */
  atex.dam.ViewUtils = _.extend({}, atex.ViewUtils, {
    toDateString: function (date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },

    timeAgo: function (date) {
      return moment(date).fromNow();
    },

    getReadableFileSizeString: function (fileSizeInBytes) {
      var i = -1;
      var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];

      do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
      } while (fileSizeInBytes > 1024);

      return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
    },

    getReadableUrl: function (url) {
      return url.replace(/^https?:\/\/(?:www\.)?/, ''); // remove protocol (http
                                                        // or https) and 'www.'
    },

    getIconForMimeType: function (mimeType) {
      if (mimeType === 'text/x-url') {
        return 'img/application-x-mswinurl.png';
      }

      var icon = new RegExp("^(" + _.keys(mimeTypeIconMappings).join("|") + ")\/.*").exec(mimeType);
      icon = icon ? icon.pop() : 'default';

      return mimeTypeIconMappings[icon];
    },

    getThumbNailUrl: function (file, callback) {
      var mainType = new RegExp("^(" + _.keys(mimeTypeIconMappings).join("|") + ")\/.*").exec(file.type);
      mainType = mainType ? mainType.pop() : 'default';

      if (mainType !== 'image') {
        callback(mimeTypeIconMappings[mainType]);
      } else {
        var canvas = document.createElement('canvas');
        var image = new Image();

        image.onload = function () {
          var maxSize = 128;
          var ratio = 1;

          if (image.height > maxSize || image.width > maxSize) {
            if (image.height > image.width) {
              ratio = maxSize / image.height;
            } else {
              ratio = maxSize / image.width;
            }
          }

          var imageX = ratio * image.width;
          var imageY = ratio * image.height;

          var offsetX = imageX < maxSize ? (maxSize - imageX) / 2 : 0;
          var offsetY = imageY < maxSize ? (maxSize - imageY) / 2 : 0;

          canvas.setAttribute('width', 128);
          canvas.setAttribute('height', 128);

          var ctx = canvas.getContext('2d');

          ctx.drawImage(image, offsetX, offsetY, imageX, imageY);
          callback(canvas.toDataURL());
        };

        var reader = new FileReader();
        reader.onload = (function (aImg) {
          return function (e) {
            aImg.src = e.target.result;
          };
        })(image);

        reader.readAsDataURL(file);
      }
    },

    /*
     patchDateInterval and unPatchDateInterval are used to get rid of date Publication or Creation
     not expressed in terms of utc midnight
     */
    patchDateInterval: function (dateArray) {
      if (!dateArray || !dateArray.length || dateArray.length !== 2) {
        return;
      }
      var millisShift = ((12 * 60 * 60) - 1) * 1000; // 11 hours, 59 mins, 59secs
      var from = dateArray[0];
      var to = dateArray[1];
      if (from.endsWith("00:00:00.000Z") || from.endsWith("00:00:00Z")) {
        var fromDate = new Date(from);
        dateArray[0] = atex.dam.AngularUtils.toUTCDate(fromDate.getTime() - millisShift);
      }
      if (to.endsWith("00:00:00.000Z") || to.endsWith("00:00:00Z")) {
        var toDate = new Date(to);
        dateArray[1] = atex.dam.AngularUtils.toUTCDate(toDate.getTime() + millisShift);
      }
    },

    /*
     patchDateInterval and unPatchDateInterval are used to get rid of date Publication or Creation
     not expressed in terms of utc midnight
     */
    patchDateIntervalFullRange: function (dateArray) {
      if (!dateArray || !dateArray.length || dateArray.length !== 2) {
        return;
      }
      var from = dateArray[0];
      var to = dateArray[1];
      if (from.endsWith("00:00:00.000Z") || from.endsWith("00:00:00Z")) {
        var fromDate = new Date(from);
        var tmpFromDate = atex.dam.AngularUtils.toUTCDate(fromDate.getTime());
        dateArray[0] = tmpFromDate.substring(0,tmpFromDate.indexOf("T"))+ "T00:00:00.000Z";
      }
      if (to.endsWith("00:00:00.000Z") || to.endsWith("00:00:00Z")) {
        var toDate = new Date(to);
        var tmpToDate = atex.dam.AngularUtils.toUTCDate(toDate.getTime());
        dateArray[1] = tmpToDate.substring(0,tmpToDate.indexOf("T"))+ "T23:59:59.000Z";
      }
    },

    unPatchDateInterval: function (dateArray) {
      if (!dateArray || !dateArray.length || dateArray.length !== 2) {
        return;
      }
      var millisShift = ((12 * 60 * 60) - 1) * 1000; // 11 hours, 59 mins, 59secs
      var from = dateArray[0];
      var to = dateArray[1];
      if (from.endsWith("12:00:01Z")) {
        var fromDate = new Date(from);
        dateArray[0] = atex.dam.AngularUtils.toUTCDate(fromDate.getTime() + millisShift);
      }
      if (to.endsWith("11:59:59Z")) {
        var toDate = new Date(to);
        dateArray[1] = atex.dam.AngularUtils.toUTCDate(toDate.getTime() - millisShift);
      }
    },

    checkViewStateArray: function(viewsStateArray, valdrEvent, formName) {
      var hasError = false;
      // Reset the state for all views
      for (var viewStateIdx in viewsStateArray) {
        if (viewsStateArray.hasOwnProperty(viewStateIdx)) {
          viewsStateArray[viewStateIdx][0].bool = false;
        }
      }
      // Iterate to check if views have errors and set the returned hasError
      var template = valdrEvent.currentScope.template;
      var myForm = valdrEvent.currentScope[formName || 'myForm'];
      for (var invalidFieldIndex in myForm.$error.valdr) {
        if (myForm.$error.valdr.hasOwnProperty(invalidFieldIndex)) {
          for (var viewIdx in template.layout.views) {
            if (template.layout.views.hasOwnProperty(viewIdx)) {
              if (template.layout.views[viewIdx].fields.indexOf(myForm.$error.valdr[invalidFieldIndex].$name) !== -1) {
                for (var stateIdx in viewsStateArray) {
                  if (viewsStateArray.hasOwnProperty(stateIdx)) {
                    if (viewsStateArray[stateIdx][0].label === template.layout.views[viewIdx].label) {
                      viewsStateArray[stateIdx][0].bool = true;
                      hasError = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
      return hasError;
    },

    viewHasError: function(view, viewsStateArray, template) {
      if (viewsStateArray.length === 0) {
        // Initialize view state array
        for (var layoutView in template.layout.views) {
          if (template.layout.views.hasOwnProperty(layoutView)) {
            var data = [
              {
                "label": template.layout.views[layoutView].label,
                "bool": false
              }
            ];
            viewsStateArray.push(data);
          }
        }
      }
      // Check if the view has error
      for (var state in viewsStateArray) {
        if (viewsStateArray.hasOwnProperty(state)) {
          if (view.label === viewsStateArray[state][0].label) {
            //return the state for the current view
            return viewsStateArray[state][0].bool;
          }
        }
      }
    }
  });

})(_, moment);
